export default "<router-outlet></router-outlet>\n<router-outlet name=\"sidebar\"></router-outlet>\n<router-outlet name=\"navbar\"></router-outlet>"